<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-input
                    :disabled="model.codigo"
                    :validations="validations.nome"
                    label="Nome"
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :disabled="model.codigo"
                    :validations="validations.abreviacao"
                    label="Abreviação"
                    v-model="model.abreviacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input
                    :disabled="model.codigo"
                    :validations="validations.sigla"
                    label="Sigla"
                    uppercase
                    v-model="model.sigla"
                />
            </rkm-col>

            <rkm-col cols="8">
                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.calendario"
                >
                    Calendário
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 300,
                },
                abreviacao: {
                    required: true,
                    min: 1,
                    max: 100,
                },
                sigla: {
                    required: true,
                    min: 1,
                    max: 100,
                },
            }
        },
    },
    created() {
        this.repositories = {
            vacina: this.getConectaSusRepository('cadastro.vacina')
        }
    },
    data: () => ({
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.vacina.edit(this.id)
                    .then(response => {
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {
                this.repositories.vacina.create()
                    .then(response => {
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        if (this.model.id) {
                            this.repositories.vacina
                                .update(this.model.id, this.camelObjectKeysToSnakeRecursive(this.model))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        } else {
                            this.repositories.vacina.store(this.camelObjectKeysToSnakeRecursive(this.model))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }
                    }
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>